import { useContext, useEffect, useState } from "react";
import {
  getFunctionalities,
} from "../services/console/functionalities";
import { AppContext } from "../context";

type UseType = "DATA" | "ACTIONS";
type ActionType = "CREATE" | "UPDATE" | "DELETE";

const handleConsoleFunctionalityActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: (a:any)=>{},
        fnMsg: t("Translations.translationsApiCreateLabel"),
      };
    case "UPDATE":
      return {
        actionFn: (a:any)=>{},
        fnMsg: t("Translations.translationsApiUpdateLabel"),
      };
    case "DELETE":
      return {
        actionFn: (a:any)=>{},
        fnMsg: t("Translations.translationsApiDeleteLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useConsoleFunctionality = (type: UseType) => {
  const {
    t,
    toast,
    appState: { selectedApp },
    setAppState,
  } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const translationAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleConsoleFunctionalityActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getFunctionalities())
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [toast, reload, type]);

  return {
    data,
    translationAction,
    reloadFn,
  };
};
